/**
 * Estimate read-time (in minutes) for an HTML body string.
 *
 * Strips HTML tags, counts plain-text words, divides by an average reading
 * pace of 225 WPM, rounds up. Minimum return value is 1 — even a one-word
 * post displays "1 min read" rather than "0 min read".
 *
 * Used by BlogPostPage's metadata strip (byline · date · read-time).
 */

const WORDS_PER_MINUTE = 225;

export function calculateReadTime(html: string): number {
    const plainText = html.replace(/<[^>]+>/g, ' ');
    const words = plainText
        .split(/\s+/)
        .filter((word) => word.length > 0);
    const minutes = Math.ceil(words.length / WORDS_PER_MINUTE);
    return Math.max(1, minutes);
}
